import { Component, input, output, ViewEncapsulation } from '@angular/core';

import { cn } from '@valk-nx/core/lib/core';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

export type TileAlignment = 'horizontal' | 'vertical';

@Component({
	encapsulation: ViewEncapsulation.None,
	imports: [SVG_ICON_IMPORTS],
	selector: 'vp-tile',
	templateUrl: './tile.html',
})
export class TileComponent {
	icon = input.required<string>();
	id = input.required<string>();
	title = input.required<string>();
	alignment = input<TileAlignment>('vertical');

	preventClickEvents = input<boolean>(false);

	emitClick = output<void>();

	cn = cn;

	openLink(): void {
		this.emitClick.emit();
	}
}
